import React from 'react';
import { Checkbox, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

const StyledCheckbox = styled(Checkbox)`
    pointer-events: none;

    &.checkbox--green {
        .ant-checkbox-inner {
            /* Green-7 */
            /* background-color: #389E0D !important;  */
            /* border-color: #389E0D !important; */
        }

    }
`;

const isDebug = false;
function AuditCheckboxGroup({
    checkboxOptions = [],
    valueBefore = [],
    valueAfter = [],
    label,
    disabled,
    align = 'vertical',
    style = {},
}) {
    const options = isDebug ? [
        {
            label: 'Apple',
            value: 'apple',
        },
        {
            label: 'Pear',
            value: 'pear',
        },
        {
            label: 'Orange',
            value: 'orange',
        },
    ] : checkboxOptions;
    const before = isDebug ? ['apple', 'orange'] : valueBefore;
    const after = isDebug ? ['pear'] : valueAfter;

    const preprocessedOptions = options.map(option => {
        const { value } = option;
        let diff = 'unchanged';

        if (!before.includes(value) && after.includes(value))
            diff = 'added';

        else if (before.includes(value) && !after.includes(value))
            diff = 'deleted';

        return {
            ...option,
            diff,
            checked: after.includes(value),
        };
    });

    return (
        <>
            {label && <div>{label}</div>}
            <div className={`ant-checkbox-group ${align}`} style={{...style}}>
                {preprocessedOptions.map(({ label, value, diff, checked }) => {
                    const style = {};
                    let className = '';

                    if (diff === 'deleted') {
                        style.textDecoration = 'line-through';
                        style.opacity = 0.7;
                        style.backgroundColor = '#ffa39e';
                        className = 'checkbox--removed';
                    }
                    else if (diff === 'added') {
                        style.backgroundColor = '#b7eb8f';
                        // style.fontWeight = 500;
                        className = 'checkbox--green';
                    }

                    return (
                        <div>
                            <StyledCheckbox
                                key={value}
                                checked={checked}
                                className={className}
                                disabled={disabled}
                            >
                                <Text style={{ whiteSpace: 'pre-wrap', ...style }}>{label}</Text>
                            </StyledCheckbox>
                            {/* {getAdditionalText(diff)} */}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default AuditCheckboxGroup;
